import React, { useEffect, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
// import { store } from './store/store';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { store2 } from './store2/store2';
import { ScrollProvider } from './router/Scroll/ScrollContext';
 
import ConfigService from './services/ConfigService';

//http://138.201.249.173:8080/swagger-ui.html#/

const Wrapper = ({ children }) => {
  const location = useLocation();
 /*  useEffect(() => {
    fetch('/config.json')
       .then((response) => response.json())
       .then((data) => {   
         for(const [key,value] of Object.entries(data)){  ConfigService[key] =value;   }

       })
       .catch((err) => {
          console.log(err.message);
       });
 }, []); */

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};

const Config = ({ children }) => {
   
   useEffect(() => {
    fetch('/config.json')
       .then((response) => response.json())
       .then((data) => {   
         for(const [key,value] of Object.entries(data)){  ConfigService[key] =value;   }

       })
       .catch((err) => {
          console.log(err.message);
       });
 }, []);  

   
  return children;
};


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

 
    
    <Provider store={store2}>
      <BrowserRouter basename='/'>
        <ScrollProvider>
        <Wrapper> 
          <App /> 
          </Wrapper>
        </ScrollProvider>
      </BrowserRouter>
    </Provider>
   
 

);
reportWebVitals();